/**
 * Map cameras remembered per history entry — the `map` namespace of the shared
 * store in `historyMemory.ts`, which is where the keying and pruning rules live.
 *
 * Only the camera is remembered, not the layers: `mode` is a prop derived from
 * the screen's own data, so it is rebuilt on arrival anyway. What cannot be
 * rebuilt is where the user had put the map.
 */

import { historyKey, readHistoryEntry, writeHistoryEntry } from '@/utils/historyMemory'

/**
 * A camera, flattened to three numbers rather than a Leaflet `LatLng` + zoom.
 * Keeping the store free of Leaflet types is what lets it be unit-tested without
 * the map, and mirrors `MapViewport` in `mapMode.ts` staying a plain interface.
 */
export interface RememberedView {
  lat: number
  lng: number
  zoom: number
}

const NAMESPACE = 'map'

export function mapViewKey(position: number, id: string, fullPath: string): string {
  return historyKey(position, NAMESPACE, id, fullPath)
}

export function readMapView(key: string): RememberedView | undefined {
  return readHistoryEntry<RememberedView>(key)
}

export function writeMapView(key: string, view: RememberedView): void {
  writeHistoryEntry(key, view)
}
